const REPORT_FILTERING = [
    {
        reportId: TYPE.SALES_BY_PROVIDER_SUMMARY,
        isShowDateRange: true
    },
    {
        reportId: TYPE.SALES_BY_PROVIDER_DETAILS,
        isShowProviderOptions: true,
        isShowItemClass: true,
        isShowItemCategory: true,
        isShowCategorySales: true,
        categorySales: true,
        export_scopes: EXPORT_SCOPES,
        isShowDateRange: true
    },
    {
        reportId: TYPE.TRANSACTIONS_DETAIL, // 39
        isShowDateRange: true
    },
    {
        reportId: TYPE.ARR, // ACCOUNT RECEIVABLE RECONCILIATION
        isShowDateRange: true
    },
    {
        reportId: TYPE.PRODUCTION_CREDIT_BY_SALES,
        isShowProviderOptions: true,
        isShowItemClass: true,
        isShowItemCategory: true,
        isShowAllSalesCategory: 0,
        isShowDateRange: true,
        export_scopes: EXPORT_SCOPES
    },
    {
        reportId: TYPE.PRODUCTION_CREDIT_BY_PAYMENTS,
        isShowProviderOptions: true,
        isShowItemClass: true,
        isShowItemCategory: true,
        isShowAllSalesCategory: 0,
        isShowDateRange: true,
        export_scopes: EXPORT_SCOPES
    }
];
import { TYPE, EXPORT_SCOPES } from "@/constants/report";

export default {
    REPORT_FILTERING
};
export { REPORT_FILTERING };
